var text = {
    footer: {
        mensenlinq: function (arg) { return "<a href=\"".concat(arg, "\" target=\"_blank\">Powered by <span>Mensenlinq</span></a>"); }
    },
    search: {
        firstName: {
            label: "First name",
            placeholder: "persons first name"
        },
        lastName: {
            label: "last name",
            placeholder: "persons family name"
        },
        birthPlace: {
            label: "Birth place",
            placeholder: "Amsterdam"
        },
        passingPlace: {
            label: "passing place",
            placeholder: "Utrecht"
        },
        birthDate: {
            label: "Birth date",
            placeholder: "07"
        },
        passingDate: {
            label: "Passing date",
            placeholder: "07"
        },
        searchbutton: {
            label: "Search"
        },
        search: {
            placeholder: "Search Name, Area, Date"
        }
    },
    rememberMe: {
        condolence: "Condolences",
        reply: function (arg) { return "Reply to ".concat(arg || ""); },
        condolencetext: {
            flower: "Placed flowers.",
            candle: "Light a candle"
        },
        info: {
            date: "Date",
            time: "Time",
            location: "Location",
            parking: "Parking",
            title: "Practical informatie",
            titles: {
                condolence: "Condolence",
                funeral: "Funeral",
                stream: "Stream",
                lastwishes: "Last Wishes"
            }
        },
        about: {
            readMore: "Read more",
            readLess: "Read less",
            blocks: {
                readMore: "Meer tonen",
                readLess: "Toon minder"
            }
        },
        templates: {
            comment: {
                reactions: "reacts"
            }
        },
        advertisements: "Advertisements",
        gallery: "Gallery",
        services: "Services",
        actions: "Add your condolence",
        over: function (arg) { return "Over ".concat(arg); },
        navigation: {
            about: function () { return function (arg) { return "Over ".concat(arg); }; },
            condolences: "Condolences",
            information: "Pratical Information",
            media: "Photos",
            advertisements: "Advertisements"
        },
        condolences: {
            noentries: "No condolences found on this page"
        },
        personDetails: function (args) {
            var bornPlace = args[0], bornDate = args[1], passedPlace = args[2], passedDate = args[3];
            var result = "";
            if (bornPlace || bornDate) {
                result += "Born";
                if (bornPlace) {
                    result += " in ".concat(bornPlace);
                }
                if (bornDate) {
                    result += ": ".concat(bornDate);
                }
            }
            if (passedPlace || passedDate) {
                // separator for born + passed
                if (result.length > 0) {
                    result += " • ";
                }
                result += "Passed";
                if (passedPlace) {
                    result += " in ".concat(passedPlace);
                }
                if (passedDate) {
                    result += ": ".concat(passedDate);
                }
            }
            return result;
        }
    },
    actions: {
        write: {
            title: "Write condolence"
        },
        flower: {
            title: "Place flowers"
        },
        candle: {
            title: "Light a candle"
        },
        form: {
            firstName: {
                label: "First name",
                placeholder: " "
            },
            lastName: {
                label: "Last name",
                placeholder: " "
            },
            email: {
                label: "E-mail",
                placeholder: " "
            },
            videoUrl: {
                label: "Youtube video link",
                placeholder: " "
            },
            message: {
                label: "Message",
                placeholder: " "
            },
            button: {
                label: "Submit"
            }
        },
        submit: {
            success: {
                title: "Condolence sent",
                message: "Your condolence has been sent to Mensenlinq, it could take time before you see it on this page."
            },
            error: {
                title: "Error, something went wrong",
                message: "Did you fill in all fields correctly? there could also be a problem with the system."
            }
        }
    },
    pagination: {
        next: 'Next',
        previous: 'Previous',
        first: 'First',
        last: 'Last',
        loadMore: 'Load more',
    },
    variables: {
        rememberMe: {
            blocks: {
                "Burgelijke staat": "Burgelijke staat",
                "Hobby / vrije tijd": "Hobby / vrije tijd",
                Opleiding: "Opleiding",
                Werk: "Werk",
                Sport: "Sport",
                Eten: "Eten",
                Muziek: "Muziek",
                Huisdier: "Huisdier",
                Vakantie: "Vakantie"
            }
        }
    },
    dateformats: {
        ago: "ago",
        seconds: function (amount) { return "".concat((amount === 1) ? 'second' : 'seconds'); },
        minutes: function (amount) { return "".concat((amount === 1) ? 'minute' : 'minutes'); },
        hours: function (amount) { return "".concat((amount === 1) ? 'hour' : 'hours'); },
        days: function (amount) { return "".concat((amount === 1) ? 'day' : 'days'); },
        months: function (amount) { return "".concat((amount === 1) ? 'month' : 'months'); },
        years: function (amount) { return "".concat((amount === 1) ? 'year' : 'years'); },
    }
};
export default text;
